import TpRadioBase from '../radio/tp-radio-base.js';
import SelectionBaseMixin from './tp-selection-base-mixin.js';
import HelperTextMixin from '../../mixins/helper-text-mixin.js';
import eventPath from '../../../edge-browser-support/event-path.js';
import { internal } from '../../../vendor/elix.js';

class TpSelectionRadio extends HelperTextMixin(SelectionBaseMixin(TpRadioBase)) {

  get [internal.template]() {
    const template = super[internal.template];
    const helperText = template.content.querySelector('.helpertext');
    template.content.querySelector('.wrapper').append(helperText);
    return template;
  }

  onLabelClick(e) {
    if (this.checked || eventPath(e)[0].id === 'inner') {
      return;
    }
    this[internal.ids].inner.dispatchEvent(new Event('change'));
  }
}

export default TpSelectionRadio;
